//https://blog.csdn.net/qq_30669833/article/details/81701588
import axios from 'axios'
// qs.parse()是将URL解析成对象的形式
// qs.stringify()是将对象 序列化成URL的形式，以&进行拼接
// qs文档https://blog.csdn.net/sansan_7957/article/details/82227040
import qs from 'qs'

let isDebug = true
let baseUrl = "http://192.168.31.182:8087"

// 添加请求拦截器，在发送请求之前做些什么(**具体查看axios文档**)--------------------------------------------
axios.interceptors.request.use(function (request) {
  // 显示loading
  if (isDebug) {
    console.log('----------------请求开始----------------');
    console.log(request.baseURL + request.url);
    if (request.data) {
      console.log(qs.parse(request.data));
    }
    if (request.params) {
      console.log(request.params);
    }
    console.log('----------------参数部分----------------');
  }
  return request
}, function (error) {
  // 请求错误时弹框提示，或做些其他事
  return Promise.reject(error)
})

// 添加响应拦截器(**具体查看axios文档**)----------------------------------------------------------------
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么，允许在数据返回客户端前，修改响应的数据
  // 如果只需要返回体中数据，则如下，如果需要全部，则 return response 即可
  if (isDebug) {
    console.log('----------------响应结果----------------');
    console.log(response.data);
    console.log('----------------请求结束----------------');
  }
  return response.data
}, function (error) {
  // 对响应错误做点什么
  if (isDebug) {
    console.log('----------------响应结果----------------');
    console.log(error);
    console.log('----------------请求结束----------------');
  }
  return Promise.reject(error)
})

// 封装数据返回成功提示函数---------------------------------------------------------------------------
function successState (res) {
  // 隐藏loading
  // 统一判断后端返回的错误码(错误码与后台协商而定)
  return res
}

// 封装数据返回失败提示函数---------------------------------------------------------------------------
function errorState (error) {
  // 隐藏loading
  // 如果http状态码正常，则直接返回数据
  if (error && error.message) {
    // 如果不需要除了data之外的数据，可以直接 return response.data
    return error
  } else {
    return {code: 'unknown', message: '服务器异常'}
  }
}

// 封装axios--------------------------------------------------------------------------------------
// baseUrlType: Magento, WS, Search
// data结构：
// {
//   baseUrlType: 'WS',
//   showLoading: true,
//   contentType: 'application/json',
//   params: {'a': b, 'c': c}
// }
function apiAxios (method, url, data) {
  data = data ? data : {};

  var requestHeader = {
    'Content-Type': data.contentType ? data.contentType : 'application/json',
    'Authorization': 'Bearer abcdef',
    'Accept': '*/*',
  }
  let httpDefault = {
    headers: requestHeader,
    method: method,
    // baseURL: baseUrl,
    url: url,
    // `params` 是即将与请求一起发送的 URL 参数
    // `data` 是作为请求主体被发送的数据
    params: method === 'GET' || method === 'DELETE' ? data.data : null,
    data: method === 'POST' || method === 'PUT' ? qs.stringify(data.data) : null,
    timeout: 30000
  }
 // 注意**Promise**使用(Promise首字母大写)
 return new Promise((resolve, reject) => {
   axios(httpDefault)
     // 此处的.then属于axios
     .then((response) => {
       successState(response)
       resolve(response)
     }).catch((error) => {
       errorState(error)
       reject(error)
     })
 })
}

export function httpGet(url, data) {
  return apiAxios('GET', url, data);
}

export function httpPost(url, data) {
  return apiAxios('POST', url, data);
}

// 输出函数getAxios、postAxios、putAxios、delectAxios，供其他文件调用-----------------------------
// Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
export default {
  install: function (Vue) {
    Vue.prototype.httpGet = (url, data) => apiAxios('GET', url, data)
    Vue.prototype.httpPost = (url, data) => apiAxios('POST', url, data)
    Vue.prototype.httpPut = (url, data) => apiAxios('PUT', url, data)
    Vue.prototype.httpDelete = (url, data) => apiAxios('DELETE', url, data)
  }
}

// 注：如果上述export default是如下写法，则不需要再mian.js中引入，直接在需要使用的文件中import，并使用即可。例如用axios.get()调用get方法；
 // export default {
 //   get: (method, url, params) => apiAxios('get', url, params),
 //   post: (method, url, params) => apiAxios('post', url, params)
 // }




// WEBPACK FOOTER //
// ./src/network/Net.js